import React, { useEffect } from "react"
import { Button, ButtonLoader } from "../../components/Button"
import { Card, CardBody, CardModal, CardTitle } from "../../components/Card"
import { PivotTable } from "../../components/Dashboard"
import { PickerWithType } from "../../components/DatePicker"
import { Label, SelectInput } from "../../components/Form"
import { HeaderContent } from "../../components/Header"
import { ModalBody, ModalFooter, ModalHeader, ModalPanel } from "../../components/Modal"
import { useForm } from "react-hook-form"
import { useScope } from "../../container/SelectProjectCompanyContainer"
import moment from 'moment'

export const optionsFilterMultiple = (dw, field, key, values = [], key1, values1 = []) => {
  if (!(dw && dw[field])) {
    return []
  }

  if (dw?.scopeType !== "project") {
    if (Array.isArray(values)) {
      return dw[field]
    } else {
      return dw[field].filter(
        (item) => values1.length === 0 || values1.map((item) => item.value).includes(item[key1]),
      )
    }
  }

  if (Array.isArray(values)) {
    return dw[field].filter(
      (item) =>
        values.map((item) => item.value).includes(item[key]) &&
        (values1.length === 0 || values1.map((item) => item.value).includes(item[key1])),
    )
  } else {
    return dw[field].filter(
      (item) =>
        values &&
        values.includes(item[key]) &&
        (values1.length === 0 || values1.map((item) => item.value).includes(item[key1])),
    )
  }
}

export const FilterModal = ({
  type,
  useFarmers = true,
  modalIsOpen,
  setModalIsOpen,
  onChange,
  control,
  onSearch,
  loading,
  dw = {},
  values,
  period = false,
  useQuestions = true,
  useForms = true,
  periodReference = false,
  hasButtons = true,
  hasFilterType = false,
  hasTags = false,
  loadingDw,
}) => {
  console.log({dw, hasTags})
  const filterType = values?.filterType && values?.filterType?.label

  return (
    <ModalPanel modalIsOpen={modalIsOpen} width={500}>
      <ModalHeader closeModal={() => setModalIsOpen(false)} title="Filtro"></ModalHeader>
      <ModalBody>
        <div className="scroll-select-modal">
          {hasFilterType && (
            <>
              <Label label="Filtrar por: " />
              <SelectInput
                handleChange={onChange("filterType")}
                isSearchable={false}
                isClearable={true}
                name="filterType"
                options={(dw && dw.filterType) || []}
                control={control}
                defaultValue={values?.filterType || []}
                isOverModal={true}
              />
            </>
          )}
          {filterType === "Organização" && (
            <>
              <Label label="Organização" />
              <SelectInput
                handleChange={onChange("scope")}
                closeMenuOnSelect={false}
                isSearchable
                isClearable={false}
                isMulti
                name="organizations"
                options={(dw && dw.organizations) || []}
                control={control}
                defaultValue={values?.scope || []}
                isOverModal={true}
              />
            </>
          )}
          {filterType === "Empresa" && (
            <>
              <Label label="Empresas" />
              <SelectInput
                handleChange={onChange("scope")}
                closeMenuOnSelect={false}
                isSearchable
                isClearable={false}
                isMulti
                name="companies"
                options={(dw && dw.companies) || []}
                control={control}
                defaultValue={values?.scope || []}
                isOverModal={true}
              />
            </>
          )}
          {filterType === "Projetos" && (
            <>
              <Label label="Projetos" />
              <SelectInput
                handleChange={onChange("scope")}
                closeMenuOnSelect={false}
                isSearchable
                isClearable={false}
                isMulti
                name="projects"
                options={(dw && dw.projects) || []}
                control={control}
                defaultValue={values?.scope || []}
                isOverModal={true}
                isDisabled={loading || loadingDw}
                resetFields={!values?.scope?.length}
              />
            </>
          )}
          {useFarmers && (
            <>
              <Label label="Usuários" />
              <SelectInput
                handleChange={onChange("farmers")}
                closeMenuOnSelect={false}
                isSearchable={true}
                isMulti={true}
                name="farmers"
                options={dw?.farmers ? dw?.farmers.sort((a, b) => {
                  return a.label.localeCompare(b.label)
                }) : []}
                defaultValue={values?.farmers || []}
                control={control}
                isOverModal={true}
                isDisabled={loading || loadingDw}
                resetFields={!values?.scope?.length}
              />
            </>
          )}
          {dw && dw?.tecnico && (
            <>
              <Label label="Tags" />
              <SelectInput
                handleChange={onChange("tags")}
                closeMenuOnSelect={false}
                isSearchable={true}
                isMulti={true}
                name="tag"
                defaultValue={values?.tags || []}
                options={dw?.tags}
                control={control}
                isOverModal={true}
              />
            </>
          )}
          {period ? (
            <>
              <Label label="Data Inicial" />
              <PickerWithType
                type={type}
                onChange={onChange("year")}
                className={"class-period"}
                // defaultValue={values?.date && values?.date}
              />
            </>
          ) : (
            <></>
          )}
          {periodReference ? (
            <>
              <Label label="Data de Referência" />
              <PickerWithType
                type={type}
                onChange={onChange("yearReference")}
                className={"class-period"}
                defaultValue={values?.date && values?.date}
              />
            </>
          ) : (
            <></>
          )}
          {hasTags && (
            <>
              <Label label="Tags" />
              <SelectInput
                handleChange={onChange("tags")}
                closeMenuOnSelect={false}
                isSearchable={true}
                isMulti={true}
                name="tags"
                options={dw?.tags || []}
                control={control}
                value={values?.tags || []}
                isOverModal={true}
                isDisabled={loading || loadingDw}
                resetFields={!values?.scope?.length}
              />
            </>
          )}
          {useForms ? (
            <>
              <Label label="Formulários" />
              <SelectInput
                handleChange={onChange("forms")}
                closeMenuOnSelect={false}
                isSearchable={true}
                isMulti={true}
                name="forms"
                options={dw?.forms}
                value={values?.forms || []}
                control={control}
                isOverModal={true}
                isDisabled={loading || loadingDw}
                resetFields={!values?.scope?.length}
              />

              {useQuestions && (
                <>
                  <Label label="Perguntas" />
                  <SelectInput
                    handleChange={onChange("questions")}
                    closeMenuOnSelect={false}
                    isSearchable={true}
                    isMulti={true}
                    name="questions"
                    options={optionsFilterMultiple(
                      dw,
                      "questions",
                      "Projeto",
                      values.projects,
                      "Formulario",
                      values.forms,
                    )}
                    control={control}
                    value={values?.questions || []}
                    isOverModal={true}
                    isDisabled={loading || loadingDw}
                    resetFields={!values?.scope?.length}
                  />
                </>
              )}
            </>
          ) : (
            <></>
          )}
        </div>
      </ModalBody>
      {hasButtons && (
        <ModalFooter>
          <ButtonLoader
            className="button-engagement"
            messageProcess="Buscando dados..."
            loading={loading || loadingDw}
            handleClick={onSearch}
            color="orange"
          />
        </ModalFooter>
      )}
    </ModalPanel>
  )
}

const PivotTableMemo = React.memo(({ data, dw, values }) => {
  if (values && values.year && values.year.split("|").length === 2) {
    const [startDate, endDate] = values.year.split("|")

    data = data.filter((item) => {
      const dataItem = item.Data && item.Data.value;
    
      // Verifica se a data existe e se está dentro do intervalo usando moment
      return dataItem && moment(dataItem).isBetween(startDate, endDate, 'day', '[]');
    });
  }
  
  return <PivotTable data={data} dw={dw} />
})

const DashboardScreen = ({
  dw,
  control,
  reload,
  onChange,
  values,
  onSearch,
  data,
  loading,
  modalIsOpen,
  setModalIsOpen,
  downloadModalIsOpen,
  setDownloadModalIsOpen,
  exportForms,
  exportFormsLoading,
  onChangeValues,
  valuesDownloads,
  setValuesDownloads,
}) => {
  const { projectsByScope } = useScope()
  const { control: controlForm } = useForm({
    mode: "onBlur",
  })

  useEffect(() => {
    if (projectsByScope && projectsByScope.length) {
      setValuesDownloads((prev) => ({
        ...prev,
        projects: projectsByScope.map((row) => ({
          value: row?.id,
          label: row?.description,
        })),
      }))
    }
  }, [JSON.stringify(projectsByScope)])

  const handleDownload = () => {
    if (!valuesDownloads.projects?.length) {
      alert("Selecione pelo menos um projeto antes de baixar.")
      return
    }
    exportForms(valuesDownloads)
  }

  return (
    <div className="dashboard-screen">
      <Card className="export-xlsx-card">
        <CardTitle className="flex-start" title="Exportar Formulário(s) para XLS" />
        <div className="report-screen-engagement-card__button">
          <Button label="Baixar" color="orange" handleClick={() => setDownloadModalIsOpen(true)} />
        </div>
      </Card>
      <Card className="no-border">
        <HeaderContent>
          {data && data.length > 0 && !loading && (
            <Button handleClick={() => setModalIsOpen(true)} color={"orange"} label="Filtro" />
          )}
          <CardTitle className="flex-start" title="Análise de Tabela Dinâmica" />
        </HeaderContent>
        <CardBody>
          <div className="analystic-table">
            {data && data.length > 0 && !loading && <PivotTableMemo {...{ dw, data, values }} />}
            {data && data.length === 0 && (
              <div className="analystic-table__button">
                <Button handleClick={() => setModalIsOpen(true)} color={"orange"} label="Iniciar" />
              </div>
            )}
          </div>
        </CardBody>
      </Card>
      <FilterModal
        {...{
          modalIsOpen,
          setModalIsOpen,
          hasFilterType: true,
          period: true,
          onChange,
          control,
          reload,
          onSearch,
          loading,
          dw,
          values,
        }}
      />
      <FilterModal
        {...{
          useProjects: true,
          modalIsOpen: downloadModalIsOpen,
          setModalIsOpen: setDownloadModalIsOpen,
          onChange: onChangeValues,
          control: controlForm,
          reload,
          onSearch: handleDownload,
          loading: exportFormsLoading,
          period: true,
          dw,
          hasTags: true,
          values: valuesDownloads,
        }}
      />
    </div>
  )
}

export default DashboardScreen
